import { render, staticRenderFns } from "./DashboardPage_New.vue?vue&type=template&id=c39a5fa8&scoped=true"
import script from "./DashboardPage_New.vue?vue&type=script&lang=js"
export * from "./DashboardPage_New.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage_New.vue?vue&type=style&index=0&id=c39a5fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a5fa8",
  null
  
)

export default component.exports